import { useState, useContext } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { PitchContext } from "../context/PitchContex";

function PaymentFailed() {
  const [bookingID, setBookingID] = useState(null);
  const { slug } = useParams();
  const {
    backendURL,
    setPending,
    setIsErr,
    setAlertMessage,
    setShowAlert,
    user,
  } = useContext(PitchContext);

  const removeBooking = async () => {
    try {
      axios.post(backendURL + "booking/remove", {
        userID: user._id,
        bookingID: JSON.parse(localStorage.getItem("bookingID")),
        pitchID: slug,
      });
    } catch (error) {
      console.error("Error removing booking:", error);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-50 p-4 text-center">
      <div className="bg-white shadow-xl rounded-2xl p-10 max-w-xl w-full">
        <div className="text-[72px] mb-4">❌</div>
        <h1 className="text-3xl font-semibold mb-4 text-gray-800">
          Ödeme Durumu
        </h1>
        <p className="text-xl text-gray-700 mb-6">
          Ödeme başarısız oldu. Lütfen tekrar deneyin.
        </p>
        {bookingID && (
          <div className="bg-gray-100 rounded-lg p-4 text-base text-gray-700 font-mono mb-4">
            <strong>Rezervasyon Kodu:</strong> {bookingID}
          </div>
        )}

        <p className="text-base text-green-700 font-medium">
          Bir hata olduğunu düşündüğünüzde, lütfen bizimle iletişime geçin.
        </p>
      </div>
    </div>
  );
}

export default PaymentFailed;
